module.exports = __webpack_public_path__ + "static/media/machine1.43d594e2.png";